/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DeliveryEventEnum = {
    Delivered: 'DELIVERED',
    Opened: 'OPENED',
    Clicked: 'CLICKED',
    Bounced: 'BOUNCED',
    Error: 'ERROR'
} as const;
export type DeliveryEventEnum = typeof DeliveryEventEnum[keyof typeof DeliveryEventEnum];

